import { SelectChangeEvent } from 'src/components/MuiGenerals';
import { SingleSelection } from '../../../../components';
import { useTranslation } from '../../../../hooks';
import useVipLevels from 'src/hooks/useVipLevels';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: SelectChangeEvent<any>) => void;
  onClear: () => void;
}

const VipLevelSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { EnumVipLevels } = useVipLevels();

  const { tc } = useTranslation();

  return (
    <SingleSelection
      label={label || tc('phSelection', { fieldName: tc('vipLevel') })}
      value={value || ''}
      onChange={onChange}
      clearSelect={onClear}
      enumData={EnumVipLevels}
      nameFn={(item) => item}
    />
  );
};

export default VipLevelSingleSelection;
